module.exports = __webpack_public_path__ + "static/media/cellfinate_antes_despues_2.aaac2cfd.jpg";